module.exports = __webpack_public_path__ + "img/cptx1@2x.984a9036.png";